import { closeRamsSigningModal } from '../State/ramsSigningModal'
import fetchRamsSignings from "../Services/fetchRamsSignings";

export default () => (dispatch) => {

  dispatch(closeRamsSigningModal())
    dispatch(fetchRamsSignings())

}
